module.exports = __webpack_public_path__ + "static/media/credit-card-solid.3422de24.svg";